module.exports = __webpack_public_path__ + "static/media/2.b0813147.webp";